import { useCallback, useEffect, useState } from 'react'

import { stringifyRawGraph } from '@/clients/http'
import { OrderModel as OrderApi } from '@/http/models/Order/Order'

import { ORDER_STATUS } from '@/constants/statuses'
import { OrderModel } from '@/types/model/Order'

const ORDER_GROUPS_GRAPH = `{total.count,pending(status=${ORDER_STATUS.PENDING}).count,active(status=${ORDER_STATUS.ACTIVE}).count,ready_to_ship(status=${ORDER_STATUS.READY_TO_SHIP}).count,dispatched(status=${ORDER_STATUS.DISPATCHED}).count,on_the_way(status=${ORDER_STATUS.ON_THE_WAY}).count,delivered(status=${ORDER_STATUS.DELIVERED}).count,cancelled(status=${ORDER_STATUS.CANCELLED}).count,returned(status=${ORDER_STATUS.RETURNED}).count,partially_returned(status=${ORDER_STATUS.PARTIALLY_RETURNED}).count}`

export const useFetchOrderGroups = () => {
  const [groups, setGroups] = useState<OrderModel.OrderGroups | null>(null)
  const [loading, setLoading] = useState(false)

  const fetchGroups = useCallback(async () => {
    setLoading(true)
    try {
      const response = await OrderApi.getGroups({
        query: {
          graph_enc: stringifyRawGraph(ORDER_GROUPS_GRAPH),
        },
      })

      if (response.success && response.data?.result) {
        setGroups(response.data.result)
      }
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchGroups()
  }, [fetchGroups])

  return {
    groups,
    loading,
    refresh: fetchGroups,
  }
}
